import { Link } from "@mui/material";
import Typography from "@mui/material/Typography";
import { DateWithTooltip } from "components/DateWithTooltip";
import PropTypes from "prop-types";
import React from "react";
import { styled } from "@mui/material/styles";
import { UserAvatar } from "components/Avatar/UserAvatar";
import buildUserName from "core/utils/build_user_name";
import { SeverityIcon } from "components/SeverityIcon";
import { useSeverity } from "hooks/severity-types/useSeverity";

export const AlertOccurrenceListItem = React.memo(
  function AlertOccurrenceListItem({ alertOccurrence }) {
    const { severityName, colour } = useSeverity(alertOccurrence.severity_id);

    const actionTaken = ({ action, dismissed_reason, case_id }) => {
      switch (action) {
        case "new":
          return (
            <>
              <Link
                href={`/pages/case-management/${case_id}`}
                color="inherit"
                underline="always"
              >
                New Case Created
              </Link>
            </>
          );
        case "add":
          return (
            <>
              <Link
                href={`/pages/case-management/${case_id}`}
                color="inherit"
                underline="always"
              >
                Added to existing Case
              </Link>
            </>
          );
        case "drop":
          return `Dismissed: ${dismissed_reason}`;
        case "sup":
          return "Superseded";
        default:
          throw new Error(`Unhandled action type: ${action}`);
      }
    };

    return (
      <ListItem>
        {/* TODO: Add entry for alert occurrence user reference */}
        {/*<Typography>#abcdef</Typography>*/}
        <SectionWrapper>
          <SeverityIcon
            severityId={alertOccurrence.severity_id}
            colour={colour}
          />
          <div>
            <Typography variant="body1">{severityName}</Typography>
            <Typography variant="body2">
              <DateWithTooltip date={alertOccurrence.alert_date} showTime />
            </Typography>
          </div>
        </SectionWrapper>
        <SectionWrapper>
          <div>
            <Typography>{actionTaken(alertOccurrence)}</Typography>
            <Typography variant="body2">
              <DateWithTooltip date={alertOccurrence.actioned_date} showTime />
            </Typography>
          </div>
          {/* TODO: get name of user and use it to create a user avatar*/}
          <UserAvatar
            name={buildUserName({
              first_name: alertOccurrence.actioned_by_first_name,
              last_name: alertOccurrence.actioned_by_last_name
            })}
          />
        </SectionWrapper>
      </ListItem>
    );
  }
);

AlertOccurrenceListItem.propTypes = {
  alertOccurrence: PropTypes.object
};

const ListItem = styled("div")`
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border-radius: 3px;
  padding: ${props => props.theme.spacing(2)};
  gap: ${props => props.theme.spacing(1)};
  justify-content: space-around;
  align-items: center;
`;

const SectionWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.theme.spacing(2)};
`;
